export const Capitalize = (word) => {
  const newWord = word.replace(/_/g, " ").toLowerCase();

  return newWord.charAt(0).toUpperCase() + newWord.slice(1);
};
